import { render, staticRenderFns } from "./UpdateProspectUrlPage.vue?vue&type=template&id=023f06c6&scoped=true"
import script from "./UpdateProspectUrlPage.vue?vue&type=script&lang=js"
export * from "./UpdateProspectUrlPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f06c6",
  null
  
)

export default component.exports